import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { SmartSmsPeriodType } from 'src/app/core/api/models';
import { PeriodTypeValue } from 'src/app/core/enums/period-type-value.enum';
import { SmsSentPeriodType } from '../../../core/api/models/sms-sent-period-type';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
    selector: 'app-periodic-type',
    templateUrl: './periodic-type.component.html',
    standalone: false
})
export class PeriodicTypeComponent implements OnInit {
  //#region properties

  @Input() config: PeriodicTypeConfig;
  @Input() inputClass: string = 'tw-px-1';
  @Input() isSmartSms: boolean = false;

  @Output('periodType') output_periodType = new EventEmitter<any>();
  @Output('periodText') output_periodText = new EventEmitter<any>();

  periodType;
  periodText;
  periodTypeTextForTitle: string;

  // for periodText title
  smsSentPeriodTypes;
  // periodType options list
  PeriodTypeValue = this.utilityService.enumToObjectWithTranslate(
    PeriodTypeValue,
    'PeriodTypeValue'
  );
  get SmartSmsPeriodType() {
    return SmartSmsPeriodType;
  }

  //#endregion

  constructor(private utilityService: UtilityService) {}

  ngOnInit() {
    if (!this.config.isTextParser)
      this.smsSentPeriodTypes = this.utilityService.enumToObjectWithTranslate(
        SmsSentPeriodType,
        'SmsSentPeriodType'
      );
    else
      this.smsSentPeriodTypes = this.utilityService.enumToObjectWithTranslate(
        SmsSentPeriodType,
        'PeriodTypeValue'
      );

    if (this.config.isSmartCampaign)
      this.smsSentPeriodTypes = this.utilityService.enumToObjectWithTranslate(
        SmartSmsPeriodType,
        'SmsSentPeriodType'
      );

    this.initValues();
  }

  ngOnChanges(): void {
    this.initValues();
  }

  initValues() {
    if (this.config?.periodType) this.periodType = this.config?.periodType;
    else this.periodType = SmsSentPeriodType.Minute;

    if (this.config?.periodText) this.periodText = this.config?.periodText;

    this.onChangePeriodType(this.periodType);
    this.emitPeriodText(this.periodText);
  }

  onChangePeriodType(type?) {
    if (this.isSmartSms) {
      this.config.periodTextControl.clearValidators();
      if (type == SmartSmsPeriodType.Minute) {
        this.config?.periodTextControl.addValidators([
          Validators.required,
          Validators.min(10),
        ]);
      } else {
        this.config?.periodTextControl.addValidators([Validators.required]);
      }
      this.config.periodTextControl.updateValueAndValidity();
    }
    this.periodTypeTextForTitle = this.PeriodTypeValue[type - 1].key;
    this.emitPeriodType();
  }

  getNumber(num) {
    if (typeof num == 'number') {
      return num;
    }

    let number: Number = +num?.toString()?.getJustNumber();
    if (number) return +number;
    else return 0;
  }

  emitPeriodType() {
    this.output_periodType.emit(this.periodType);
  }

  emitPeriodText(periodText) {
    if (periodText?.target?.value)
      this.periodText = this.getNumber(periodText?.target?.value);
    this.output_periodText.emit(this.periodText);
  }
}
export interface PeriodicTypeConfig {
  periodTypeLabel?: string;
  periodTextLabel?: string;
  periodTypeControl?: FormControl;
  periodTextControl?: FormControl;
  responsiveClassName?: string;
  periodType?: any;
  periodText?: any;
  isTextParser?: boolean;
  isSmartCampaign?: boolean;
  isDisableSentDelayType?: boolean;
}
